export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-50/80">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            <div className="col-span-2 md:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50">香蕉漫画</span>
              <p className="text-xs md:text-sm text-background-50/60 mt-3 leading-relaxed max-w-[240px]">
                精选热门韩漫、日漫、国漫分类推荐，涵盖恋爱、奇幻、热血等所有风格，为漫迷提供高清漫画免费在线阅读和人气排行榜。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-3">快速导航</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '焦点专题', href: '#carousel' },
                  { label: '精选漫画', href: '#cards' },
                  { label: '人气排行', href: '#ranking' },
                  { label: '最新动态', href: '#updates' },
                  { label: '漫画分类', href: '#index' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                    className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-3">帮助中心</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '常见问题', href: '#faq' },
                  { label: '联系我们', href: '#contact' },
                  { label: '关于我们', href: '#about' },
                  { label: 'APP下载', href: '#app' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                    className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-3">合作伙伴</h4>
              <p className="text-xs md:text-sm text-background-50/50 leading-relaxed">
                合作品牌及平台信息即将公布，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/50">
              &copy; 2024-2026 香蕉漫画. 本站为漫画推荐与索引平台，倡导支持正版漫画。
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-bilibili-line', label: 'B站' },
              ].map((social) => (
                <span
                  key={social.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/50 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  title={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}